import React, { useEffect } from "react";
import { FormHelperText } from "@material-ui/core";
import { Editor } from "@tinymce/tinymce-react";
import { useTranslation } from "react-i18next"; // ✅ Import useTranslation

// Import TinyMCE resources directly (SELF-HOSTED)
import "tinymce/tinymce";
import "tinymce/icons/default";
import "tinymce/themes/silver";
import "tinymce/plugins/advlist";
import "tinymce/plugins/autolink";
import "tinymce/plugins/lists";
import "tinymce/plugins/link";
import "tinymce/plugins/image";
import "tinymce/plugins/charmap";
import "tinymce/plugins/print";
import "tinymce/plugins/preview";
import "tinymce/plugins/anchor";
import "tinymce/plugins/searchreplace";
import "tinymce/plugins/visualblocks";
import "tinymce/plugins/code";
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/insertdatetime";
import "tinymce/plugins/media";
import "tinymce/plugins/table";
import "tinymce/plugins/contextmenu";
import "tinymce/plugins/paste";
import "tinymce/plugins/wordcount";

export const renderTextEditor = ({
    input,
    label,
    meta: { touched, error },
    ...custom
}) => {
    const { t } = useTranslation(); // ✅ useTranslation hook

    useEffect(() => {
        // Remove the need for API key by self-hosting
        window.tinymce.baseURL = "/tinymce"; // Path to TinyMCE assets
    }, []);

    return (
        <div>
            <Editor
                label={label}
                {...input}
                {...custom}
                onEditorChange={(content) => {
                    input.onChange(content); // Update form value
                }}
                onBlur={() => {
                    input.onBlur(); // Trigger blur event for validation
                }}
                init={{
                    height: 400,
                    menubar: true,
                    plugins: [
                        "advlist autolink lists link image charmap print preview anchor",
                        "searchreplace visualblocks code fullscreen",
                        "insertdatetime media table contextmenu paste imagetools wordcount",
                    ],
                    toolbar:
                        "undo redo | formatselect | bold italic backcolor | " +
                        "alignleft aligncenter alignright alignjustify | " +
                        "bullist numlist outdent indent | removeformat | help",
                    branding: false,
                    content_style:
                        "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                }}
            />
            {touched && error && (
                <FormHelperText error>{t(error)}</FormHelperText> // ✅ Translated error
            )}
        </div>
    );
};


//import React, { useEffect } from "react";
//import { FormHelperText } from "@material-ui/core";
//import { Editor } from "@tinymce/tinymce-react";

//// Import TinyMCE resources directly (SELF-HOSTED)
//import "tinymce/tinymce";
//import "tinymce/icons/default";
//import "tinymce/themes/silver";
//import "tinymce/plugins/advlist";
//import "tinymce/plugins/autolink";
//import "tinymce/plugins/lists";
//import "tinymce/plugins/link";
//import "tinymce/plugins/image";
//import "tinymce/plugins/charmap";
//import "tinymce/plugins/print";
//import "tinymce/plugins/preview";
//import "tinymce/plugins/anchor";
//import "tinymce/plugins/searchreplace";
//import "tinymce/plugins/visualblocks";
//import "tinymce/plugins/code";
//import "tinymce/plugins/fullscreen";
//import "tinymce/plugins/insertdatetime";
//import "tinymce/plugins/media";
//import "tinymce/plugins/table";
//import "tinymce/plugins/contextmenu";
//import "tinymce/plugins/paste";
//import "tinymce/plugins/wordcount";

//export const renderTextEditor = ({
//    input,
//    label,
//    meta: { touched, error },
//    ...custom
//}) => {
//    useEffect(() => {
//        // Remove the need for API key by self-hosting
//        window.tinymce.baseURL = "/tinymce"; // Path to TinyMCE assets
//    }, []);

//    return (
//        <div>
//            <Editor
//                label={label}
//                {...input}
//                {...custom}
//                onEditorChange={(content) => {
//                    input.onChange(content); // Update form value when editor content changes
//                }}
//                onBlur={() => {
//                    input.onBlur(); // Trigger form's onBlur event
//                }}
//                init={{
//                    height: 400,
//                    menubar: true,
//                    plugins: [
//                        "advlist autolink lists link image charmap print preview anchor",
//                        "searchreplace visualblocks code fullscreen",
//                        "insertdatetime media table contextmenu paste imagetools wordcount"
//                    ],
//                    toolbar:
//                        "undo redo | formatselect | bold italic backcolor | \
//                        alignleft aligncenter alignright alignjustify | \
//                        bullist numlist outdent indent | removeformat | help",
//                    branding: false, // Remove "Powered by TinyMCE" branding
//                    content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }"
//                }}
//            />
//            <FormHelperText error={error && touched}>
//                {touched && error}
//            </FormHelperText>
//        </div>
//    );
//};


//import React from "react";
//import { FormHelperText } from "@material-ui/core";
//import { Editor } from "@tinymce/tinymce-react";

//export const renderTextEditor = ({
//	input,
//	label,
//	meta: { touched, error },
//	...custom
//}) => {
//	return (
//		<div>
//			<Editor
//				label={label}
//				{...input}
//				{...custom}
//				onEditorChange={(content) => {
//					input.onChange(content); // Update the form value when the editor content changes
//				}}
//				onBlur={() => {
//					input.onBlur(); // Trigger the form's onBlur event
//				}}
//				init={{
//					height: 400,
//					convert_urls: false,
//					plugins: [
//						"advlist autolink lists link image charmap print preview anchor",
//						"searchreplace visualblocks code fullscreen",
//						"insertdatetime media table contextmenu paste imagetools wordcount"
//					],
//					toolbar:
//						"insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image"
//				}}
//			/>
//			<FormHelperText error={error && touched}>
//				{touched && error}
//			</FormHelperText>
//		</div>
//	);
//};



//import React from "react";
//import { FormHelperText } from "@material-ui/core";
//import tinymce from "tinymce/tinymce";
//import "tinymce/themes/modern/theme";
//import "tinymce/plugins/advlist";
//import "tinymce/plugins/autolink";
//import "tinymce/plugins/lists";
//import "tinymce/plugins/link";
//import "tinymce/plugins/image";
//import "tinymce/plugins/charmap";
//import "tinymce/plugins/print";
//import "tinymce/plugins/preview";
//import "tinymce/plugins/anchor";
//import "tinymce/plugins/searchreplace";
//import "tinymce/plugins/visualblocks";
//import "tinymce/plugins/code";
//import "tinymce/plugins/fullscreen";
//import "tinymce/plugins/insertdatetime";
//import "tinymce/plugins/media";
//import "tinymce/plugins/table";
//import "tinymce/plugins/contextmenu";
//import "tinymce/plugins/paste";
//import "tinymce/plugins/imagetools";
//import "tinymce/plugins/wordcount";

//import { Editor } from "@tinymce/tinymce-react";

//export const renderTextEditor = ({
//	input,
//	label,
//	meta: { touched, error },
//	...custom
//}) => {
	
//	return (
//		<div>
//			<Editor
//				label={label}
//				{...input}
//				{...custom}
//				onBlur={event => {
//					input.onChange(event.target.getContent());
//				}}
//				init={{
//					height: 400,
//                    convert_urls: false,
//                    skin_url: '/tinymce/skins/lightgray',
//					plugins: [
//						"advlist autolink lists link image charmap print preview anchor",
//						"searchreplace visualblocks code fullscreen",
//						"insertdatetime media table contextmenu paste imagetools wordcount"
//					],
//					toolbar:
//						"insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image"
//				}}
//			/>
//			<FormHelperText error={error && touched}>
//				{touched && error}
//			</FormHelperText>
//		</div>
//	);
//};
